import React from "react";
import { FaComments, FaClipboardList, FaFileAlt, FaCogs, FaHandsHelping } from "react-icons/fa";

const steps = [
  { title: "Contact Us", desc: "Share your requirement on call or WhatsApp.", icon: FaComments },
  { title: "Free Consultation", desc: "We suggest the right service + timeline + cost.", icon: FaClipboardList },
  { title: "Document Collection", desc: "Easy checklist. Share documents securely.", icon: FaFileAlt },
  { title: "Work Execution", desc: "We file/execute and keep you updated.", icon: FaCogs },
  { title: "Ongoing Support", desc: "Post-filing support for notices and questions.", icon: FaHandsHelping }
];

export default function Process() {
  return (
    <section id="process" className="section">
      <div className="mx-auto max-w-7xl container-pad">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">
          Simple steps. Clear communication. WhatsApp-friendly updates—designed for busy Indian founders and working professionals.
        </p>

        <div className="mt-10 grid gap-5 lg:grid-cols-5 sm:grid-cols-2">
          {steps.map((s, idx) => (
            <div key={s.title} className="card p-6 relative">
              <div className="flex items-start gap-3">
                <div className="h-12 w-12 rounded-2xl bg-navy-50 flex items-center justify-center border border-navy-900/5">
                  <s.icon className="text-navy-900" size={20} />
                </div>
                <div>
                  <div className="text-xs font-semibold text-navy-800/60">Step {idx + 1}</div>
                  <h3 className="font-heading text-lg text-navy-900">{s.title}</h3>
                </div>
              </div>
              <p className="mt-3 text-sm text-navy-800/75">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-navy-900 text-white p-6 sm:p-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5">
            <div>
              <div className="font-heading text-2xl">You’ll always know what’s happening</div>
              <p className="mt-2 text-sm text-white/85 max-w-2xl">
                We share a checklist, timeline, and status updates so you never feel lost—perfect for first-time founders and busy professionals.
              </p>
            </div>
            <a href="#contact" className="inline-flex items-center justify-center rounded-xl bg-gold-500 px-5 py-3 font-semibold text-navy-900 transition hover:opacity-95">
              Get Started
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
